export interface BreadcrumbModel {
  routerLink: string;
  name: string;
}

export enum BreadcrumbTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface BreadcrumbInput {
  breadcrumbs: BreadcrumbModel[];
  breadcrumbNumber: number;
  theme: BreadcrumbTheme;
  homePage: string;
}
